import { useMutation } from '@tanstack/react-query';
import { useAxios } from 'context/AxiosContextProvider';

import config from '../../config';
export default function useDeleteServiceRecordDocumentMutations() {
  const axios = useAxios();

  return useMutation({
    mutationFn: (documentId: number) => {
      return axios.delete(`${config.apiBaseUrl}/op/v1/document/${documentId}`);
    },
  });
}
